import styled from 'styled-components';
import { zIndex } from 'tokens';

export const DropdownMenu = styled.div`
	position: absolute;
	left: 0;
	right: 0;
	padding-top: 4px;
	padding-bottom: 4px;
	gap: 4px;
	background: ${(p) => p.theme.gray[100]};
	border: 1px solid ${(p) => p.theme.gray[200]};
	border-radius: 8px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
	z-index: ${zIndex.panelOverlay};
	overflow: hidden;
`;

export const DropdownMenuItem = styled.button`
	display: flex;
	align-items: center;
	gap: 10px;
	padding-left: 14px;
	padding-right: 12px;
	border-radius: 6px;
	transition: background-color 0.2s ease;
	font-size: 13px;
	color: ${(p) => p.theme.gray[1000]};
	height: 48px;
	width: 100%;
	border: none;
	background: transparent;
	text-align: left;
	font-weight: 400;
	font-family: inherit;

	&:hover:not([disabled]) {
		background-color: ${(p) => p.theme.gray[200]};
	}

	&:active:not([disabled]) {
		background-color: ${(p) => p.theme.gray[200]};
	}

	&:disabled {
		opacity: 0.5;
	}
`;
